import { createUseStyles } from "react-jss";
import soonCard from "/src/images/pages/ru-index/soon.svg";
import soonCardEn from "/src/images/pages/ru-index/soon-en.svg";
import soonGiftCard from "/src/images/pages/ru-index/soon-gift.svg";
import soonGiftCardEn from "/src/images/pages/ru-index/soon-gift-en.svg";

export const useStyles = createUseStyles({
  carouselMainContainer: {
    "& .react-multi-carousel-list": {
      margin: "0 -12px",
      flexWrap: "wrap",
      zIndex: 1,
      "@media (max-width: 1200px)": {
        overflow: "visible !important"
      },
      "@media (max-width: 600px)": {
        margin: "0 -6px"
      },
      "& .react-multi-carousel-item": {
        padding: "0 12px",
        "& > div": {
          height: "100%",
          boxShadow: "0px 12px 12px rgb(45 36 66 / 15%)"
        },
        "@media (max-width: 600px)": {
          padding: "0 6px",
          "&.react-multi-carousel-item--active": {
            "& > div > div > div:first-child": {
              "& > div.MediaCard": {
                transform: "scale(1.2)"
              },
              "&:after": {
                transform: "translate(-50%, 21px)"
              }
            }
          }
        }
      },
      "& .react-multi-carousel-dot-list": {
        marginTop: 56,
        position: "static",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        "& li": {
          width: 16,
          height: 16,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexShrink: 0,
          margin: 8,
          "&.react-multi-carousel-dot--active": {
            "& button": {
              background: "#65C15D"
            }
          },
          "& button": {
            margin: 0,
            padding: 0,
            border: "none",
            width: "100%",
            height: "100%",
            background: "rgb(255, 255, 255, 0.2)"
          },
        },
        "@media (max-width: 1200px)": {
          marginTop: 76
        },
        "@media (max-width: 600px)": {
          marginTop: 32
        }
      }
    },
    "& .carousel-button-group": {
      width: "100%",
      position: "absolute",
      top: "50%",
      transform: "translateY(calc(-50% - 40px))",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      zIndex: 0,
      "& .carousel-button-item": {
        width: 56,
        height: 56,
        borderRadius: "50%",
        border: "1px solid #FFFFFF",
        backgroundColor: "transparent",
        background:
          "url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.7 4.7C12.3134 4.3134 11.6866 4.3134 11.3 4.7C10.9134 5.0866 10.9134 5.7134 11.3 6.1L16.2 11H5C4.44771 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H16.2L11.3 17.9C10.9134 18.2866 10.9134 18.9134 11.3 19.3C11.6866 19.6866 12.3134 19.6866 12.7 19.3L19.2929 12.7071C19.6834 12.3166 19.6834 11.6834 19.2929 11.2929L12.7 4.7Z' fill='white'/%3E%3C/svg%3E%0A\")",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        fontSize: 0,
        cursor: "pointer",
        transition: "all .5s",
        "&:hover": {
          backgroundColor: "#7770FF",
          borderColor: "#7770FF"
        },
        "&.previous": {
          transform: "rotate(-180deg)",
          marginLeft: -96
        },
        "&.next": {
          marginRight: -96
        },
        "&.disabled": {
          opacity: 0.5,
          cursor: "default",
          "&:hover": {
            backgroundColor: "transparent",
            borderColor: "#FFFFFF"
          }
        }
      },
      "@media (max-width: 1200px)": {
        display: "none",
      }
    }
  },
  carouselMainTitle: {
    color: "#FFF",
    textAlign: "center",
    marginBottom: 64,
    "@media (max-width: 1200px)": {
      textAlign: "left",
    },
    "@media (max-width: 600px)": {
      marginBottom: 40,
    },
  },
  carouselMainWrapper: {
    position: "relative",
  },
  staticCards: {
    display: "flex",
    "& $staticCard": {
      width: "33.3%",
      boxShadow: "0px 12px 12px rgb(45 36 66 / 15%)",
      minHeight: "704px",
      "@media (max-width: 1200px)": {
        width: "50%",
        "&:nth-child(3)": {
          display: "none"
        }
      },
      "@media (max-width: 600px)": {
        width: "100%",
        "&:nth-child(2)": {
          display: "none"
        },
        "&:nth-child(3)": {
          display: "none"
        }
      },
      "&:nth-child(2)": {
        marginLeft: 24,
        marginRight: 24,
        "@media (max-width: 1200px)": {
          marginRight: 0
        }
      }
    }
  },
  staticCard: {
    borderRadius: 8,
    position: "relative",
    overflow: "hidden"
  },
  soonCard: {
    background: `url(${soonCard}) no-repeat`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  soonCardEn: {
    background: `url(${soonCardEn}) no-repeat`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  soonGiftCard: {
    background: `url(${soonGiftCard}) no-repeat`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  soonGiftCardEn: {
    background: `url(${soonGiftCardEn}) no-repeat`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  skeletonCard: {
    width: "33.3%",
    backgroundColor: "#FFFFFF",
    overflow: "hidden",
    position: "relative",
    borderRadius: 8,
    "&:after": {
      content: "''",
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      transform: "translateX(-100%)",
      backgroundImage: "linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0))",
      animation: "$skeletonAnimation .9s infinite"
    }
  },
  skeletonElement: {
    background: "rgba(203, 206, 218, 0.5)",
    borderRadius: 4
  },
  skeletonElementXl: {
    height: 56
  },
  skeletonElementMd: {
    height: 32
  },
  skeletonElementSm: {
    height: 20
  },
  skeletonElementShort: {
    maxWidth: 200
  },
  skeletonCardMedia: {
    height: 220,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  skeletonCardInfo: {
    paddingTop: 20,
    paddingRight: 32,
    paddingBottom: 32,
    paddingLeft: 32
  },
  skeletonCardInfoDate: {},
  skeletonCardInfoTheme: {
    marginTop: 24
  },
  skeletonCardInfoDescription: {
    marginTop: 24,
    "& + $skeletonCardInfoDescription": {
      marginTop: 8
    }
  },
  skeletonCardInfoPrize: {
    marginTop: 46
  },
  skeletonCardInfoCode: {
    marginTop: 46
  },
  skeletonCardInfoButton: {
    marginTop: 24
  },
  "@keyframes skeletonAnimation": {
    "100%": {
      transform: "translateX(100%)"
    }
  }
});
